
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img src="https://static.readdy.ai/image/d59b18a86b2c4da172af70cd0d419253/e7f50c5a512809dd1b1927e02624ebd4.png" alt="Freeworkers Logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-2xl font-bold">Freeworkers</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              AI 기술로 비즈니스를 자동화하고 혁신하는 전문 에이전시
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">서비스</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  AI 챗봇 개발
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  업무 프로세스 자동화
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  AI 데이터 분석
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  맞춤형 AI 솔루션
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">회사</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  회사 소개
                </a>
              </li>
              <li>
                <a href="#cases" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  고객 사례
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  블로그
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  문의하기
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">연락처</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-teal-400 mt-1"></i>
                <a href="mailto:contact@freeworkers.ai" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  contact@freeworkers.ai
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-teal-400 mt-1"></i>
                <a href="tel:+821012345678" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  +82 10-0000-0000
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  서울특별시 강남구<br />테헤란로 123
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Freeworkers. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                개인정보처리방침
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                이용약관
              </a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
